import {
    useContext,
} from 'react'

import TableActionsContext, {
    TableActionsContextValue,
} from './TableActionsContext'

const useTableActionsContext = (): TableActionsContextValue => {
    const context = useContext(TableActionsContext)

    if (context === undefined) {
        return {} as TableActionsContextValue
    }

    return context
}

export default useTableActionsContext
